var map = {
	"./svg/2column.svg": 57340,
	"./svg/4column.svg": 51356,
	"./svg/arrow-down.svg": 69528,
	"./svg/arrow-left.svg": 78296,
	"./svg/arrow-next.svg": 94425,
	"./svg/arrow-prev.svg": 39966,
	"./svg/burger.svg": 48856,
	"./svg/calendar.svg": 50782,
	"./svg/camera.svg": 28662,
	"./svg/card-cvv.svg": 85110,
	"./svg/card-num.svg": 42817,
	"./svg/close.svg": 81691,
	"./svg/document.svg": 31722,
	"./svg/done.svg": 56127,
	"./svg/e-flower.svg": 13195,
	"./svg/e-fruit.svg": 89954,
	"./svg/e-leaf.svg": 87900,
	"./svg/e-root.svg": 21673,
	"./svg/edit.svg": 66958,
	"./svg/fertilizing.svg": 76112,
	"./svg/log-out.svg": 85889,
	"./svg/minus.svg": 70934,
	"./svg/moon.svg": 75275,
	"./svg/more-dots.svg": 89504,
	"./svg/notification.svg": 78262,
	"./svg/plus.svg": 66219,
	"./svg/profile.svg": 94163,
	"./svg/search.svg": 58857,
	"./svg/send.svg": 85241,
	"./svg/sheild.svg": 20269,
	"./svg/trash.svg": 81211,
	"./svg/watering.svg": 28945,
	"./svg/zodiac.svg": 86062,
	"./svgo/animal-cat.svg": 42608,
	"./svgo/animal-dog.svg": 67536,
	"./svgo/animal-parrot.svg": 49656,
	"./svgo/close-modal.svg": 70273,
	"./svgo/info.svg": 76839,
	"./svgo/star.svg": 66179,
	"./svgo/toxic.svg": 63041,
	"./svgo/unlimited.svg": 14974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49566;